import { render, staticRenderFns } from "./navFooter.vue?vue&type=template&id=5141cc36&"
import script from "./navFooter.vue?vue&type=script&lang=js&"
export * from "./navFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports